<template>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12 px-gap">
        <div
          class="bg-white p-l-20 p-t-20 p-r-20 p-b-10 rounded shade"
          data-v-step="9"
        >
          <h5 class="no-margin" align="center">
            Berita Terbaru Media Konvensional
          </h5>
          <carousel-post-component :data="data[0].data" :is_single="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel_post_list from "./carousel_post_list.vue";

export default {
  name: "medkon_post_list",
  components: {
    "carousel-post-component": carousel_post_list,
  },
  props: {
    data: {
      type: Array,
    },
    is_loading: Boolean,
  },
};
</script>